import moment from 'moment';

export default function getAllWeekNumberDuringPeriode(dateDebut, dateFin) {
  if (!dateDebut || !dateFin) { return []; }
  const startDate = moment(dateDebut);
  const endDate = moment(dateFin);
  const anneeSemainePeriode = [];
  for (const startingMoment = startDate; startingMoment <= endDate; startingMoment.add(1, 'days')) {
    if (!anneeSemainePeriode.find((anneSemaine) => { return anneSemaine === moment(startingMoment).format('GGGGWW'); })) {
      anneeSemainePeriode.push(moment(startingMoment).format('GGGGWW'));
    }
  }
  return anneeSemainePeriode;
}
